function initCountdown() {
  function update() {
    const now = new Date();
    const midnight = new Date();
    midnight.setHours(24, 0, 0, 0);
    let diff = Math.floor((midnight - now) / 1000);
    
    let h = Math.floor(diff / 3600);
    diff %= 3600;
    let m = Math.floor(diff / 60);
    let s = diff % 60;
    
    const hEl = document.getElementById('cd-h');
    const mEl = document.getElementById('cd-m');
    const sEl = document.getElementById('cd-s');
    
    if (hEl) hEl.innerText = h.toString().padStart(2, '0');
    if (mEl) mEl.innerText = m.toString().padStart(2, '0');
    if (sEl) sEl.innerText = s.toString().padStart(2, '0');
  }
  update();
  setInterval(update, 1000);
}
document.addEventListener('DOMContentLoaded', initCountdown);
